var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative c" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("h3", { staticClass: "title" }, [
                _vm._v("拼团 " + _vm._s(_vm.title)),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "pageFrom",
                      attrs: {
                        inline: "",
                        size: "small",
                        model: _vm.pageFrom,
                        "label-position": "right",
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "拼团名称：" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "拼团名称",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.pageFrom.combinationName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageFrom, "combinationName", $$v)
                                },
                                expression: "pageFrom.combinationName",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.getList },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "SKU编码：" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "拼团名称",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.pageFrom.skuCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageFrom, "skuCode", $$v)
                                },
                                expression: "pageFrom.skuCode",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.getList },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-btw" }, [
                    _c(
                      "div",
                      { staticClass: "buttons" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled: !_vm.ids || !_vm.ids.length,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteBatch("")
                              },
                            },
                          },
                          [_vm._v("批量移除")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-right": "10px" },
                            attrs: { type: "primary" },
                            on: { click: _vm.exportCustomerSku },
                          },
                          [_vm._v("导出结果")]
                        ),
                        _vm._v(" "),
                        _c(
                          "ButtonUploadExcel",
                          {
                            attrs: {
                              beforeUpload: function (file) {
                                return _vm.beforeUpload(file, "updatePriceApi")
                              },
                            },
                          },
                          [_vm._v("导入更新授权与价格")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success" },
                            on: { click: _vm.addPintuanGoods },
                          },
                          [_vm._v("添加拼团")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.list,
                size: "mini",
                "highlight-current-row": "",
                "max-height": "600",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "combinationName",
                  label: "拼团商品",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuName",
                  label: "SKU名称",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuAttr",
                  label: "SKU规格",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplyPrice",
                  label: "供货价",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "distributionPrice",
                  label: "售价",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "combinationPrice",
                  label: "拼团价",
                  "min-width": "80",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { size: "mini" },
                          on: {
                            blur: function ($event) {
                              return _vm.changePrice(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.combinationPrice,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "combinationPrice", $$v)
                            },
                            expression: "scope.row.combinationPrice",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "50", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteBatch(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { margin: "10px 0" } },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [15, 30, 45, 60],
                  "page-size": _vm.pageFrom.limit,
                  "current-page": _vm.pageFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("SelectPintuan", {
        ref: "SelectPintuanRef",
        on: { doRefresh: _vm.getList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }